import { getAxiosInstance } from "../ApiConfig";

async function FetchAllServiceLines() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllServiceLineByReportingUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getMyServiceLine(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyServiceLine${page ? `?page=${page}&limit=${limit}` : ''}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AllServicePaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyServiceLine?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllServiceSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyServiceLine?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getSharedServiceLine() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedServiceLine`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllServiceLineByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllServiceLineByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getServiceLineDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneByServiceLineId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createServiceLine(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createServiceLine`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateServiceLine(id, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateServiceLine/${id}`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteServiceLine(id) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteServiceLine/${id}`);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    FetchAllServiceLines,
    getMyServiceLine,
    getSharedServiceLine,
    getAllServiceLineByCompany,
    getServiceLineDetails,
    createServiceLine,
    updateServiceLine,
    deleteServiceLine,
    AllServicePaginationSearch,
    AllServiceSearch
}